import * as _ from 'lodash-es';
import { paintTrail } from './paintTrailF.mts';
export const renderGameCanvasBg = ({ ctx, width, height }) => {
    ctx.beginPath();
    ctx.fillStyle = 'white';
    ctx.rect(0, 0, width, height);
    ctx.fill();
    ctx.closePath();
};
export const renderFinishedTrails = ({ ctx, finishedTrails }) => {
    _.reverse(_.clone(finishedTrails)).forEach((trail) => paintTrail({ ctx, trail }));
};
